import type { VoiceTypeKey } from '@/src/dal/user-dal'
import type { RefObject } from 'react'
import type { TextInput } from 'react-native'

import {
  EditNameModal,
  LanguageSelectionModal,
  RemoveAccountDialog,
  VoiceTypeSelectionModal,
} from './SettingsModals'

export function SettingsDialogs({
  canSaveName,
  editNameError,
  editNameInputRef,
  editNameValue,
  eligibleForDelete,
  isCheckingEligibility,
  isDeleting,
  isSavingName,
  language,
  selectedVoiceType,
  voiceTypeOptions,
  onChangeEditName,
  onCloseEditName,
  onCloseLanguageOptions,
  onCloseVoiceTypeOptions,
  onCloseRemoveAccount,
  onContinueAfterUnsubscribe,
  onDeleteAccount,
  onOpenUnsubscribeLink,
  onSaveName,
  onSelectLanguage,
  onSelectVoiceType,
  removeDialogStep,
  showEditNameDialog,
  showLanguageOptions,
  showVoiceTypeOptions,
  showRemoveAccountDialog,
}: {
  canSaveName: boolean
  editNameError: string | null
  editNameInputRef: RefObject<TextInput | null>
  editNameValue: string
  eligibleForDelete: boolean | undefined
  isCheckingEligibility: boolean
  isDeleting: boolean
  isSavingName: boolean
  language: string
  selectedVoiceType: VoiceTypeKey | null
  voiceTypeOptions: { key: VoiceTypeKey; label: string }[]
  onChangeEditName: (text: string) => void
  onCloseEditName: () => void
  onCloseLanguageOptions: () => void
  onCloseVoiceTypeOptions: () => void
  onCloseRemoveAccount: () => void
  onContinueAfterUnsubscribe: () => void
  onDeleteAccount: () => void
  onOpenUnsubscribeLink: () => void
  onSaveName: () => void
  onSelectLanguage: (language: 'en' | 'sv') => void
  onSelectVoiceType: (voiceType: VoiceTypeKey) => void
  removeDialogStep: 'unsubscribe' | 'confirm'
  showEditNameDialog: boolean
  showLanguageOptions: boolean
  showVoiceTypeOptions: boolean
  showRemoveAccountDialog: boolean
}) {
  return (
    <>
      <LanguageSelectionModal
        visible={showLanguageOptions}
        language={language}
        onClose={onCloseLanguageOptions}
        onSelectLanguage={onSelectLanguage}
      />

      <EditNameModal
        visible={showEditNameDialog}
        inputRef={editNameInputRef}
        value={editNameValue}
        error={editNameError}
        canSave={canSaveName}
        isSaving={isSavingName}
        onChangeText={onChangeEditName}
        onClose={onCloseEditName}
        onSave={onSaveName}
      />

      <VoiceTypeSelectionModal
        visible={showVoiceTypeOptions}
        selectedVoiceType={selectedVoiceType}
        voiceTypeOptions={voiceTypeOptions}
        onClose={onCloseVoiceTypeOptions}
        onSelectVoiceType={onSelectVoiceType}
      />

      <RemoveAccountDialog
        visible={showRemoveAccountDialog}
        step={removeDialogStep}
        eligible={eligibleForDelete}
        isDeleting={isDeleting}
        isCheckingEligibility={isCheckingEligibility}
        onClose={onCloseRemoveAccount}
        onContinueAfterUnsubscribe={onContinueAfterUnsubscribe}
        onDeleteAccount={onDeleteAccount}
        onOpenUnsubscribeLink={onOpenUnsubscribeLink}
      />
    </>
  )
}
